import styled from "styled-components";
import { FlexContainer,SecondaryButton,PrimaryButton } from "./styled";
import InviteImage from "../assets/images/inviteImage.png";
import { copyToClipboard } from "../utils";

const ContentContainer = styled(FlexContainer)`
    flex-direction: column;
    gap: 0;
    padding: 16px 22px;
    align-items: center;
    overflow-y: auto;
    padding-bottom: 24px;
`;

const InviteImageContainer = styled.div`
    width: 70%;
    height: auto;
    img{
        width: 100%;
        height: auto;
    }
`
const LinkContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 80px;
    position: relative;
    background: #6363631A;
    border-radius: 100px;
    height: 52px;
    margin-top: 16px;
    span{
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 16px;
    display: block;
    }
`
const CopyButton = styled(SecondaryButton)`
    position: absolute;
    right: 8px;
    height: 32px;
    width: 58px;
`
const InviteModalContent = ({refCode = ""}) => {
    const link = `${window.location.origin}/login?ref=${refCode}`
    const encodedLink = encodeURIComponent(link);
    return (
        <ContentContainer>
            <InviteImageContainer>
                <img src={InviteImage} alt="invite"/>
            </InviteImageContainer>
            <LinkContainer>
            <span>{link}</span>
            <CopyButton onClick={()=>copyToClipboard(link)}>Copy</CopyButton>
            </LinkContainer>
            <FlexContainer style={{padding:"24px 16px",fontSize:"14px",textAlign:"center"}}>
            Copy your link and send it to your friends
            </FlexContainer>
            {/* <a style={{width:"100%"}} href={`https://t.me/share/url?url=${encodedLink}`} rel="noreferrer">
           <PrimaryButton>Share</PrimaryButton> 
              </a> */}
        </ContentContainer>
    );
}

export default InviteModalContent;